import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "@material-ui/lab/LoadingButton/LoadingButton";
import Button from "@material-ui/core/Button";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Modal,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Alert,
  Row,
  Spinner,
} from "reactstrap";

import Fab from "Screen/Components/Basic/fab";

import { initReactI18next, useTranslation } from "react-i18next";

import validator from "validator";

import moment from "moment/moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import ReactDatetime from "react-datetime";

import { toValueLabel } from "Screen/Components/Basic/util";
import { on_username, on_judgement } from "./HistoriesOrdersValidator";
import { t } from "../../services/i18n/index";

export const HistoriesOrdersModal = ({
  modal,
  close_modal,
  searchHistoriesOrders,
  set_searchHistoriesOrders,
  dispatch_info,
  dispatch_danger,
  dispatch_put_markets_exchanges_id_cancel,
}) => {
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);

  const put_markets_exchanges_id_cancel = useSelector(
    (state) => state.reduce_put_markets_exchanges_id_cancel
  );
  const inLoading = put_markets_exchanges_id_cancel.isLoading;
  return (
    <>
      <Modal
        size="md"
        isOpen={modal}
        toggle={() => {
          close_modal();
        }}
      >
        <div className="modal-header justify-content-center pb-0">
          <h4 className="title title-up mt-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                close_modal();
              }}
            >
              <i className="nc-icon nc-simple-remove" />
            </button>
            {searchHistoriesOrders.id && (
              <img
                className="mr-3"
                alt="..."
                src={require("assets/svg/cancel.svg")}
                width="30px"
              />
            )}
            {!searchHistoriesOrders.id && (
              <img
                className="mr-3"
                alt="..."
                src={require("assets/svg/cancel.svg")}
                width="30px"
              />
            )}
            {t("注文キャンセル")}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row>
              <Col md="12">
                <FormGroup
                  className={`has-label ${searchHistoriesOrders.judgementState &&
                    "has-danger"}`}
                >
                  <label className="control-label">
                    {t("キャンセルしますか？")}
                  </label>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="modal-footer justify-content-center">
          <Container>
            <Row className="buttons-row">
              <Col md="12" sm="12">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      dispatch_put_markets_exchanges_id_cancel(
                        {
                          ...searchHistoriesOrders,
                          search: searchHistoriesOrders,
                        },
                        (d) => {
                          // dispatch_info(t('登録しました'));
                          close_modal();
                        }
                      );
                    }}
                    pending={inLoading}
                    // variant="outlined"
                    variant="contained"
                    style={{width:"100%"}}
                  >
                    {t("キャンセル")}
                  </LoadingButton>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
};
